<template>
  <Result :title="title" :state="state" :message="message"/>
</template>

<script>
import * as R from 'ramda'
import * as Bowser from "bowser"
import Result from '@/components/Results/ResultBase.vue'
import { VALID_BROWSER_WIN_7, VALID_BROWSER_MOBILE, STATE } from '@/constants.js'
export default {
  name: 'ResultOfUserEnv',
  props: {
    usrEnvSettings: {
      type: Object,
      required: true
    }
  },
  components: {
    Result
  },
  data () {
    return {
      title: '推奨動作環境',
      message: '',
      state: STATE.PROGRESS
    }
  },
  created () {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const { name: osName, versionName: osVersionName } = browser.getOS()
    const { name: browserName, version: browserVersion } = browser.getBrowser()
    const { type: platformType } = browser.getPlatform()
    const envResult = R.join(' ', [osName, osVersionName, browserName, browserVersion, platformType])
    var isValidWin7 = true
    var isValidMobileTablet = true
    if (osName === 'Windows' && osVersionName === '7') {
      // Windows7 IE11をNGにする
      var isIE = browser.satisfies(VALID_BROWSER_WIN_7)
      isValidWin7 = !isIE
    }
    // mobile / tablet
    if (R.includes(platformType, ['mobile', 'tablet'])) {
      isValidMobileTablet = browser.satisfies(VALID_BROWSER_MOBILE)
    }

    const isValidBrowser = isValidWin7 && isValidMobileTablet
    this.state = isValidBrowser ? STATE.OK : STATE.ERROR

    const getSetting = (key, prop) => R.view(R.lensPath([key, prop]), this.usrEnvSettings)
    const createMessage = (status) => {
      return getSetting(status, 'msg')
      + envResult
      + getSetting(status, 'msg2')
    }

    this.message = this.state === STATE.ERROR
    ? createMessage('notWork')
    : createMessage('work')

  }
}
</script>

<style>

</style>
